import { compare as compare_2, toString, now as now_1, op_Subtraction } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { totalDays, totalHours, totalMinutes } from "../fable_modules/fable-library-js.4.29.0/TimeSpan.js";
import { createElement } from "react";
import React from "react";
import { Title2, DrawerBody, MessageBarBody, MessageBar, DrawerHeader, DrawerHeaderTitle, OverlayDrawer, Select, Input, SkeletonItem, Skeleton, Link, Persona, Caption2, Tooltip, Body1Strong, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Button, Badge, Text as Text$, Body1, TableCellLayout, createTableColumn as createTableColumn_6, Divider, Subtitle2, Title3, tokens, Caption1, Card } from "@fluentui/react-components";
import { numberHash, equals, compare as compare_1, comparePrimitives, int32ToString, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_1, isEmpty, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { collect, toArray, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { AddRegular, DismissRegular, SearchRegular, DeleteRegular, EditRegular, PauseRegular, CheckmarkFilled } from "@fluentui/react-icons";
import { isNullOrWhiteSpace, join, compare } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { RuleExecutionStatus, RuleScope, ActionType__ToDescription, TriggerType__ToDescription } from "../Shared/RuleModels.jsx";
import { dataGrid_items_Z6D8BD2B8 } from "../fable_modules/FS.FluentUI.3.0.0/Props2.fs.js";
import { Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { useCtx } from "../Context.jsx";
import { SortDirection } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { useEffectDisposableOptOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, Rule } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";
import { map as map_2, append as append_1, indexed, choose, sortByDescending } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Array_distinct } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { DialogScope, AddRuleDialog, ExistingRule, EditRuleDialog } from "./RuleDialog.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";

function relativeTime(date) {
    const diff = op_Subtraction(now_1(), date);
    if (totalMinutes(diff) < 1) {
        return "akkurat nå";
    }
    else if (totalMinutes(diff) < 60) {
        return `${~~totalMinutes(diff)} min siden`;
    }
    else if (totalHours(diff) < 24) {
        return `${~~totalHours(diff)} timer siden`;
    }
    else if (totalDays(diff) < 7) {
        return `${~~totalDays(diff)} dager siden`;
    }
    else {
        return toString(date, "dd. MMM yyyy");
    }
}

function scopeLabel(scope) {
    switch (scope.tag) {
        case 1:
            return "Læringsløp";
        case 2:
            return "Nivå";
        default:
            return "Global";
    }
}

function scopeColor(scope) {
    switch (scope.tag) {
        case 1:
            return ["color", "brand"];
        case 2:
            return ["color", "success"];
        default:
            return ["color", "informative"];
    }
}

function statusLabel(status) {
    switch (status.tag) {
        case 1:
            return "Feilet";
        case 2:
            return "Hoppet over";
        default:
            return "Vellykket";
    }
}

function statusColor(status) {
    switch (status.tag) {
        case 1:
            return ["color", "danger"];
        case 2:
            return ["color", "warning"];
        default:
            return ["color", "success"];
    }
}

function StatCard(statCardInputProps) {
    let elems_1, elems, el, el_2;
    const accentColor = statCardInputProps.accentColor;
    const value = statCardInputProps.value;
    const label = statCardInputProps.label;
    const el_4 = Card;
    return createElement(el_4, createObj(ofArray([["appearance", "outline"], ["style", {
        position: "relative",
        overflow: "hidden",
    }], (elems_1 = [createElement("div", {
        style: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            width: 3,
            backgroundColor: accentColor,
        },
    }), createElement("div", createObj(ofArray([["style", {
        padding: 14,
        paddingLeft: 16,
    }], (elems = [(el = Caption1, createElement(el, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: label,
    })), (el_2 = Title3, createElement(el_2, {
        style: {
            marginTop: 4,
            display: "block",
        },
        children: int32ToString(value),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
}

function SectionHeader(title, subtitle) {
    let elems_1;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 12 + "px ",
        marginBottom: 12,
        marginTop: 32,
    }], (elems_1 = toList(delay(() => {
        let el;
        return append(singleton((el = Subtitle2, createElement(el, {
            style: {
                color: tokens.colorNeutralForeground2,
                textTransform: "uppercase",
                letterSpacing: 1,
            },
            children: title,
        }))), delay(() => {
            let elems, el_2;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                flexGrow: 1,
            }], (elems = [(el_2 = Divider, createElement(el_2, {}))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let el_4;
                const matchValue = subtitle;
                if (matchValue == null) {
                    return singleton(defaultOf());
                }
                else {
                    const s = matchValue;
                    return singleton((el_4 = Caption1, createElement(el_4, {
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: s,
                    })));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function RulesDataGrid(rulesDataGridInputProps) {
    let elems_4, el_36, elems_7, el_46, value_174, elems_6, props_63, el_38, name_9, el_44;
    const onDelete = rulesDataGridInputProps.onDelete;
    const onEdit = rulesDataGridInputProps.onEdit;
    const isMobile = rulesDataGridInputProps.isMobile;
    const globalRules = rulesDataGridInputProps.globalRules;
    const columns = toList(delay(() => {
        let createTableColumn;
        return append(singleton((createTableColumn = createTableColumn_6, createTableColumn({
            columnId: "status",
            compare: (delegateArg, delegateArg_1) => comparePrimitives(delegateArg.Enabled, delegateArg_1.Enabled),
            renderHeaderCell: () => "",
            renderCell: (delegateArg_3) => {
                if (delegateArg_3.Enabled) {
                    const el = CheckmarkFilled;
                    return createElement(el, {
                        primaryFill: tokens.colorStatusSuccessBorderActive,
                        fontSize: 16,
                    });
                }
                else {
                    const el_2 = PauseRegular;
                    return createElement(el_2, {
                        fontSize: 16,
                    });
                }
            },
        }))), delay(() => {
            let createTableColumn_1;
            return append(singleton((createTableColumn_1 = createTableColumn_6, createTableColumn_1({
                columnId: "name",
                compare: (delegateArg_4, delegateArg_1_1) => compare(delegateArg_4.Name, delegateArg_1_1.Name),
                renderHeaderCell: () => "Navn",
                renderCell: (delegateArg_6) => {
                    let elems;
                    const rule_1 = delegateArg_6;
                    const el_8 = TableCellLayout;
                    return createElement(el_8, {
                        children: singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 2 + "px ",
                        }], (elems = toList(delay(() => {
                            let el_4;
                            return append(singleton((el_4 = Body1, createElement(el_4, {
                                style: {
                                    fontWeight: 600,
                                },
                                children: rule_1.Name,
                            }))), delay(() => {
                                let el_6;
                                const matchValue = rule_1.Description;
                                if (matchValue == null) {
                                    return singleton(defaultOf());
                                }
                                else {
                                    const desc = matchValue;
                                    return singleton((el_6 = Caption1, createElement(el_6, {
                                        style: {
                                            color: tokens.colorNeutralForeground3,
                                        },
                                        children: desc,
                                    })));
                                }
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
                    });
                },
            }))), delay(() => {
                let createTableColumn_2;
                return append(!isMobile ? singleton((createTableColumn_2 = createTableColumn_6, createTableColumn_2({
                    columnId: "trigger",
                    compare: (delegateArg_7, delegateArg_1_2) => compare_1(delegateArg_7.TriggerType, delegateArg_1_2.TriggerType),
                    renderHeaderCell: () => "Utløser",
                    renderCell: (delegateArg_9) => {
                        let el_10;
                        const el_12 = TableCellLayout;
                        return createElement(el_12, {
                            children: singleton_1((el_10 = Text$, createElement(el_10, {
                                style: {
                                    color: tokens.colorNeutralForeground2,
                                },
                                children: TriggerType__ToDescription(delegateArg_9.TriggerType),
                            }))),
                        });
                    },
                }))) : empty(), delay(() => {
                    let createTableColumn_3;
                    return append(!isMobile ? singleton((createTableColumn_3 = createTableColumn_6, createTableColumn_3({
                        columnId: "action",
                        compare: (delegateArg_10, delegateArg_1_3) => compare_1(delegateArg_10.ActionType, delegateArg_1_3.ActionType),
                        renderHeaderCell: () => "Handling",
                        renderCell: (delegateArg_12) => {
                            let el_16, elems_1, el_14;
                            const el_18 = TableCellLayout;
                            return createElement(el_18, {
                                children: singleton_1((el_16 = Badge, createElement(el_16, createObj(ofArray([["appearance", "tint"], ["shape", "rounded"], ["color", "brand"], ["style", {
                                    whiteSpace: "nowrap",
                                }], (elems_1 = [(el_14 = Text$, createElement(el_14, {
                                    children: ActionType__ToDescription(delegateArg_12.ActionType),
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))),
                            });
                        },
                    }))) : empty(), delay(() => {
                        let createTableColumn_4;
                        return append(!isMobile ? singleton((createTableColumn_4 = createTableColumn_6, createTableColumn_4({
                            columnId: "enabled",
                            compare: (delegateArg_13, delegateArg_1_4) => comparePrimitives(delegateArg_13.Enabled, delegateArg_1_4.Enabled),
                            renderHeaderCell: () => "Status",
                            renderCell: (delegateArg_15) => {
                                let el_22;
                                const rule_4 = delegateArg_15;
                                const el_24 = TableCellLayout;
                                return createElement(el_24, {
                                    children: singleton_1((el_22 = Badge, createElement(el_22, createObj(toList(delay(() => append(singleton(["appearance", "tint"]), delay(() => append(singleton(["shape", "rounded"]), delay(() => append(rule_4.Enabled ? singleton(["color", "success"]) : singleton(["color", "subtle"]), delay(() => {
                                        let elems_2, el_20;
                                        return singleton((elems_2 = [(el_20 = Text$, createElement(el_20, {
                                            children: rule_4.Enabled ? "Aktiv" : "Pauset",
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))]));
                                    })))))))))))),
                                });
                            },
                        }))) : empty(), delay(() => {
                            let createTableColumn_5;
                            return singleton((createTableColumn_5 = createTableColumn_6, createTableColumn_5({
                                columnId: "actions",
                                renderHeaderCell: () => "",
                                renderCell: (delegateArg_17) => {
                                    let elems_3, el_28, el_26, el_32, el_30;
                                    const rule_5 = delegateArg_17;
                                    const el_34 = TableCellLayout;
                                    return createElement(el_34, {
                                        children: singleton_1(createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            gap: 4 + "px ",
                                            justifyContent: "flex-end",
                                        }], (elems_3 = [(el_28 = Button, createElement(el_28, {
                                            size: "small",
                                            appearance: "subtle",
                                            icon: (el_26 = EditRegular, createElement(el_26, {})),
                                            onClick: (_arg_6) => {
                                                onEdit(rule_5);
                                            },
                                        })), (el_32 = Button, createElement(el_32, {
                                            size: "small",
                                            appearance: "subtle",
                                            icon: (el_30 = DeleteRegular, createElement(el_30, {})),
                                            onClick: (_arg_7) => {
                                                onDelete(rule_5.Id);
                                            },
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))),
                                    });
                                },
                            })));
                        }));
                    }));
                }));
            }));
        }));
    }));
    const columnSizingOptions = toList(delay(() => append(singleton(["status", ofArray([["minWidth", 20], ["defaultWidth", 20], ["idealWidth", 20]])]), delay(() => append(singleton(["name", ofArray([["minWidth", isMobile ? 60 : 140], ["defaultWidth", isMobile ? 100 : 180], ["idealWidth", 300]])]), delay(() => append(!isMobile ? singleton(["trigger", ofArray([["minWidth", 120], ["defaultWidth", 160], ["idealWidth", 240]])]) : empty(), delay(() => append(!isMobile ? singleton(["action", ofArray([["minWidth", 160], ["defaultWidth", 200], ["idealWidth", 320]])]) : empty(), delay(() => append(!isMobile ? singleton(["enabled", ofArray([["minWidth", 100], ["defaultWidth", 100], ["idealWidth", 100]])]) : empty(), delay(() => {
        let columnWidth_2;
        return singleton((columnWidth_2 = ((isMobile ? 56 : 80) | 0), ["actions", ofArray([["minWidth", columnWidth_2], ["defaultWidth", columnWidth_2], ["idealWidth", columnWidth_2]])]));
    }))))))))))));
    if (globalRules.length === 0) {
        return createElement("div", createObj(ofArray([["style", {
            padding: 40,
            textAlign: "center",
        }], (elems_4 = [(el_36 = Body1, createElement(el_36, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Ingen automatisering opprettet ennå",
        }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
    else {
        return createElement("div", createObj(ofArray([["style", {
            width: 100 + "%",
            overflowX: "auto",
        }], (elems_7 = [(el_46 = DataGrid, createElement(el_46, createObj(ofArray([dataGrid_items_Z6D8BD2B8(globalRules), ["columns", toArray(columns)], ["sortable", true], ["resizableColumns", !isMobile], (value_174 = columnSizingOptions, ["columnSizingOptions", isEmpty(value_174) ? {} : createObj(toList(delay(() => collect((matchValue_1) => singleton([matchValue_1[0], createObj(matchValue_1[1])]), value_174))))]), ["style", {
            minWidth: 100 + "%",
        }], ["getRowId", (delegateArg_18) => delegateArg_18.Id], (elems_6 = [(props_63 = singleton_1((el_38 = DataGridRow, createElement(el_38, {
            appearance: "brand",
            children: (delegateArg_19, delegateArg_1_5) => {
                const props_58 = singleton_1(delegateArg_19.renderHeaderCell());
                const name_7 = DataGridHeaderCell;
                return createElement(name_7, {
                    children: reactApi.Children.toArray(Array.from(props_58)),
                });
            },
        }))), (name_9 = DataGridHeader, createElement(name_9, {
            children: reactApi.Children.toArray(Array.from(props_63)),
        }))), (el_44 = DataGridBody, createElement(el_44, {
            children: (delegateArg_21) => {
                const trd = delegateArg_21;
                const el_42 = DataGridRow;
                return createElement(el_42, {
                    key: trd.rowId,
                    children: (delegateArg_20, delegateArg_1_6) => {
                        let elems_5;
                        const tcd_1 = delegateArg_20;
                        const el_40 = DataGridCell;
                        return createElement(el_40, createObj(ofArray([["key", tcd_1.columnId], (elems_5 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
                    },
                });
            },
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }
}

class FilterState extends Record {
    constructor(Search, ScopeFilter, StatusFilter) {
        super();
        this.Search = Search;
        this.ScopeFilter = ScopeFilter;
        this.StatusFilter = StatusFilter;
    }
}

function FilterState_$reflection() {
    return record_type("Rules.RulePage.FilterState", [], FilterState, () => [["Search", string_type], ["ScopeFilter", string_type], ["StatusFilter", string_type]]);
}

function ExecutionLogSection(executionLogSectionInputProps) {
    let elems_5, elems_24;
    const isMobile = executionLogSectionInputProps.isMobile;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState([]);
    const logs = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setIsLoading = patternInput_2[1];
    let patternInput_3;
    const initial_2 = new FilterState("", "all", "all");
    patternInput_3 = reactApi.useState(initial_2);
    const setFilter = patternInput_3[1];
    const filter = patternInput_3[0];
    const patternInput_4 = reactApi.useState(["executedAt", new SortDirection(1, [])]);
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedLog = patternInput_5[1];
    const selectedLog = patternInput_5[0];
    useEffectDisposableOptOnce(() => {
        let pr_1;
        const pr = startAsPromise(Rule.GetExecutionLogs(0, 200));
        pr_1 = (pr.then((_arg) => {
            if (_arg.tag === 1) {
                errorToast(setCtx, "getExecutionLogsError", "Kunne ikke hente kjøringslogg", "", undefined);
                setIsLoading(false);
            }
            else {
                patternInput_1[1](_arg.fields[0]);
                setIsLoading(false);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        return undefined;
    });
    const filteredLogs = sortByDescending((log_1) => log_1.ExecutedAt, logs.filter((log) => {
        if ((((filter.Search === "") ? true : (log.RuleName.toLocaleLowerCase().indexOf(filter.Search.toLocaleLowerCase()) >= 0)) ? true : defaultArg(map((n) => (n.toLocaleLowerCase().indexOf(filter.Search.toLocaleLowerCase()) >= 0), log.UserName), false)) && ((((filter.ScopeFilter === "all") ? true : ((filter.ScopeFilter === "global") && equals(log.RuleScope, new RuleScope(0, [])))) ? true : ((filter.ScopeFilter === "track") && equals(log.RuleScope, new RuleScope(1, [])))) ? true : ((filter.ScopeFilter === "level") && equals(log.RuleScope, new RuleScope(2, []))))) {
            if (((filter.StatusFilter === "all") ? true : ((filter.StatusFilter === "success") && equals(log.Status, new RuleExecutionStatus(0, [])))) ? true : ((filter.StatusFilter === "failed") && equals(log.Status, new RuleExecutionStatus(1, [])))) {
                return true;
            }
            else if (filter.StatusFilter === "skipped") {
                return equals(log.Status, new RuleExecutionStatus(2, []));
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }), {
        Compare: compare_2,
    });
    const totalCount = filteredLogs.length | 0;
    let successCount;
    const array_3 = filteredLogs.filter((l) => equals(l.Status, new RuleExecutionStatus(0, [])));
    successCount = array_3.length;
    let failedCount;
    const array_5 = filteredLogs.filter((l_1) => {
        if (equals(l_1.Status, new RuleExecutionStatus(1, []))) {
            return true;
        }
        else {
            return equals(l_1.Status, new RuleExecutionStatus(2, []));
        }
    });
    failedCount = array_5.length;
    let uniqueUsers;
    const array_8 = Array_distinct(choose((l_2) => l_2.UserId, filteredLogs, Int32Array), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: numberHash,
    });
    uniqueUsers = array_8.length;
    const columns = toList(delay(() => {
        let createTableColumn;
        return append(singleton((createTableColumn = createTableColumn_6, createTableColumn({
            columnId: "executedAt",
            compare: (delegateArg, delegateArg_1) => compare_2(delegateArg.ExecutedAt, delegateArg_1.ExecutedAt),
            renderHeaderCell: () => "Tidspunkt",
            renderCell: (delegateArg_3) => {
                let elems;
                const log_2 = delegateArg_3;
                const el_8 = TableCellLayout;
                return createElement(el_8, {
                    children: singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 2 + "px ",
                    }], (elems = toList(delay(() => {
                        let el;
                        return append(singleton((el = Body1Strong, createElement(el, {
                            children: toString(log_2.ExecutedAt, "dd. MMM HH:mm"),
                        }))), delay(() => {
                            let el_2;
                            return append(singleton((el_2 = Caption1, createElement(el_2, {
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: relativeTime(log_2.ExecutedAt),
                            }))), delay(() => {
                                let el_6, el_4;
                                const matchValue = log_2.CycleStartDate;
                                if (matchValue == null) {
                                    return singleton(defaultOf());
                                }
                                else {
                                    const cycleLabel = "Syklus: " + toString(matchValue, "dd. MMM yyyy");
                                    return singleton((el_6 = Tooltip, createElement(el_6, {
                                        relationship: "label",
                                        content: "Syklus-dato: utløserens unike nøkkel. Reglen kjører kun én gang per dato.",
                                        children: (el_4 = Caption2, createElement(el_4, {
                                            style: {
                                                color: tokens.colorNeutralForeground3,
                                                fontStyle: "italic",
                                            },
                                            children: cycleLabel,
                                        })),
                                    })));
                                }
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
                });
            },
        }))), delay(() => {
            let createTableColumn_1;
            return append(singleton((createTableColumn_1 = createTableColumn_6, createTableColumn_1({
                columnId: "ruleName",
                compare: (delegateArg_4, delegateArg_1_1) => compare(delegateArg_4.RuleName, delegateArg_1_1.RuleName),
                renderHeaderCell: () => "Automatisering",
                renderCell: (delegateArg_6) => {
                    let el_10;
                    const el_12 = TableCellLayout;
                    return createElement(el_12, {
                        style: {
                            maxWidth: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        },
                        children: singleton_1((el_10 = Text$, createElement(el_10, {
                            style: {
                                fontWeight: 500,
                            },
                            children: delegateArg_6.RuleName,
                        }))),
                    });
                },
            }))), delay(() => {
                let createTableColumn_2;
                return append(!isMobile ? singleton((createTableColumn_2 = createTableColumn_6, createTableColumn_2({
                    columnId: "scope",
                    compare: (delegateArg_7, delegateArg_1_2) => compare_1(delegateArg_7.RuleScope, delegateArg_1_2.RuleScope),
                    renderHeaderCell: () => "Omfang",
                    renderCell: (delegateArg_9) => {
                        let el_16, elems_1, el_14;
                        const log_4 = delegateArg_9;
                        const el_18 = TableCellLayout;
                        return createElement(el_18, {
                            children: singleton_1((el_16 = Badge, createElement(el_16, createObj(ofArray([["appearance", "tint"], ["shape", "rounded"], scopeColor(log_4.RuleScope), (elems_1 = [(el_14 = Text$, createElement(el_14, {
                                children: scopeLabel(log_4.RuleScope),
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))),
                        });
                    },
                }))) : empty(), delay(() => {
                    let createTableColumn_3;
                    return append(!isMobile ? singleton((createTableColumn_3 = createTableColumn_6, createTableColumn_3({
                        columnId: "user",
                        compare: (delegateArg_10, delegateArg_1_3) => compare(defaultArg(delegateArg_10.UserName, ""), defaultArg(delegateArg_1_3.UserName, "")),
                        renderHeaderCell: () => "Bruker",
                        renderCell: (delegateArg_12) => {
                            const log_5 = delegateArg_12;
                            const el_28 = TableCellLayout;
                            return createElement(el_28, {
                                children: toList(delay(() => {
                                    let el_26, userName_1, el_24, userId, userName, el_22, elems_2, el_20;
                                    const matchValue_1 = log_5.UserName;
                                    const matchValue_2 = log_5.UserId;
                                    return (matchValue_1 == null) ? singleton((el_26 = Caption1, createElement(el_26, {
                                        style: {
                                            color: tokens.colorNeutralForeground3,
                                        },
                                        children: "—",
                                    }))) : ((matchValue_2 == null) ? ((userName_1 = matchValue_1, singleton((el_24 = Persona, createElement(el_24, {
                                        size: "small",
                                        name: userName_1,
                                        avatar: {
                                            color: "colorful",
                                        },
                                    }))))) : ((userId = (matchValue_2 | 0), (userName = matchValue_1, singleton((el_22 = Link, createElement(el_22, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["bruker", int32ToString(userId)]), 1)], (elems_2 = [(el_20 = Persona, createElement(el_20, {
                                        size: "small",
                                        name: userName,
                                        avatar: {
                                            color: "colorful",
                                        },
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))))))));
                                })),
                            });
                        },
                    }))) : empty(), delay(() => {
                        let createTableColumn_4;
                        return singleton((createTableColumn_4 = createTableColumn_6, createTableColumn_4({
                            columnId: "status",
                            compare: (delegateArg_13, delegateArg_1_4) => compare_1(delegateArg_13.Status, delegateArg_1_4.Status),
                            renderHeaderCell: () => "Resultat",
                            renderCell: (delegateArg_15) => {
                                let el_32, elems_3, el_30;
                                const log_6 = delegateArg_15;
                                const el_34 = TableCellLayout;
                                return createElement(el_34, {
                                    children: singleton_1((el_32 = Badge, createElement(el_32, createObj(ofArray([["shape", "rounded"], ["appearance", "tint"], statusColor(log_6.Status), (elems_3 = [(el_30 = Text$, createElement(el_30, {
                                        children: statusLabel(log_6.Status),
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))),
                                });
                            },
                        })));
                    }));
                }));
            }));
        }));
    }));
    const columnSizingOptions = toList(delay(() => append(singleton(["executedAt", ofArray([["minWidth", isMobile ? 70 : 100], ["defaultWidth", isMobile ? 90 : 140], ["idealWidth", 180]])]), delay(() => append(singleton(["ruleName", ofArray([["minWidth", isMobile ? 80 : 140], ["defaultWidth", isMobile ? 120 : 180], ["idealWidth", 260]])]), delay(() => append(!isMobile ? singleton(["scope", ofArray([["minWidth", 90], ["defaultWidth", 90], ["idealWidth", 90]])]) : empty(), delay(() => append(!isMobile ? singleton(["user", ofArray([["minWidth", 140], ["defaultWidth", 180], ["idealWidth", 240]])]) : empty(), delay(() => {
        let columnWidth_1;
        return singleton((columnWidth_1 = ((isMobile ? 90 : 110) | 0), ["status", ofArray([["minWidth", columnWidth_1], ["defaultWidth", columnWidth_1], ["idealWidth", columnWidth_1]])]));
    }))))))))));
    if (patternInput_2[0]) {
        const el_42 = Skeleton;
        return createElement(el_42, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 16 + "px ",
            width: 100 + "%",
        }], (elems_5 = toList(delay(() => {
            let elems_4;
            return append(!isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "grid",
                gridTemplateColumns: join(" ", [1 + "fr", 1 + "fr", 1 + "fr", 1 + "fr"]),
                gap: 12 + "px ",
            }], (elems_4 = toList(delay(() => map_1((_arg_6) => {
                const el_36 = SkeletonItem;
                return createElement(el_36, {
                    style: {
                        height: 72,
                    },
                    animation: "wave",
                    shape: "rectangle",
                });
            }, toList(rangeDouble(1, 1, 4))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                let el_38;
                return append(singleton((el_38 = SkeletonItem, createElement(el_38, {
                    style: {
                        height: 32,
                        width: 260,
                    },
                    animation: "wave",
                    shape: "rectangle",
                }))), delay(() => map_1((_arg_7) => {
                    const el_40 = SkeletonItem;
                    return createElement(el_40, {
                        style: {
                            height: 48,
                        },
                        animation: "wave",
                        shape: "rectangle",
                    });
                }, toList(rangeDouble(1, 1, 5)))));
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
    }
    else {
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 16 + "px ",
        }], (elems_24 = toList(delay(() => {
            let elems_6;
            return append(!isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "grid",
                gridTemplateColumns: join(" ", [1 + "fr", 1 + "fr", 1 + "fr", 1 + "fr"]),
                gap: 12 + "px ",
            }], (elems_6 = [createElement(StatCard, {
                label: "Utførelser",
                value: totalCount,
                accentColor: tokens.colorBrandForeground1,
            }), createElement(StatCard, {
                label: "Vellykket",
                value: successCount,
                accentColor: tokens.colorPaletteGreenForeground1,
            }), createElement(StatCard, {
                label: "Feilet/hoppet over",
                value: failedCount,
                accentColor: tokens.colorPaletteRedForeground1,
            }), createElement(StatCard, {
                label: "Unike brukere",
                value: uniqueUsers,
                accentColor: tokens.colorBrandForeground2,
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                let elems_10;
                return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => (isMobile ? append(singleton(["flexDirection", "column"]), delay(() => singleton(["gap", 8 + "px "]))) : append(singleton(["flexDirection", "row"]), delay(() => singleton(["gap", 12 + "px "])))))))))))], (elems_10 = toList(delay(() => {
                    let el_46, el_44;
                    return append(singleton((el_46 = Input, createElement(el_46, {
                        contentBefore: (el_44 = SearchRegular, createElement(el_44, {
                            fontSize: 16,
                        })),
                        placeholder: "Søk bruker eller automatisering...",
                        value: filter.Search,
                        onChange: (ev) => {
                            setFilter(new FilterState(ev.target.value, filter.ScopeFilter, filter.StatusFilter));
                        },
                        style: createObj(toList(delay(() => (isMobile ? singleton(["width", 100 + "%"]) : singleton(["width", 260]))))),
                    }))), delay(() => {
                        let elems_9, el_48, el_50;
                        return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["gap", 8 + "px "]), delay(() => (isMobile ? singleton(["width", 100 + "%"]) : empty()))))))))], (elems_9 = [(el_48 = Select, createElement(el_48, createObj(toList(delay(() => append(singleton(["value", filter.ScopeFilter]), delay(() => append(singleton(["onChange", (ev_1) => {
                            setFilter(new FilterState(filter.Search, ev_1.target.value, filter.StatusFilter));
                        }]), delay(() => append(isMobile ? singleton(["style", {
                            flexGrow: 1,
                        }]) : empty(), delay(() => {
                            let elems_7;
                            return singleton((elems_7 = [createElement("option", {
                                value: "all",
                                children: "Alle omfang",
                            }), createElement("option", {
                                value: "global",
                                children: "Global",
                            }), createElement("option", {
                                value: "track",
                                children: "Læringsløp",
                            }), createElement("option", {
                                value: "level",
                                children: "Nivå",
                            })], ["children", reactApi_1.Children.toArray(Array.from(elems_7))]));
                        }))))))))))), (el_50 = Select, createElement(el_50, createObj(toList(delay(() => append(singleton(["value", filter.StatusFilter]), delay(() => append(singleton(["onChange", (ev_2) => {
                            setFilter(new FilterState(filter.Search, filter.ScopeFilter, ev_2.target.value));
                        }]), delay(() => append(isMobile ? singleton(["style", {
                            flexGrow: 1,
                        }]) : empty(), delay(() => {
                            let elems_8;
                            return singleton((elems_8 = [createElement("option", {
                                value: "all",
                                children: "Alle resultater",
                            }), createElement("option", {
                                value: "success",
                                children: "Vellykket",
                            }), createElement("option", {
                                value: "failed",
                                children: "Feilet",
                            }), createElement("option", {
                                value: "skipped",
                                children: "Hoppet over",
                            })], ["children", reactApi_1.Children.toArray(Array.from(elems_8))]));
                        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => append(!isMobile ? singleton(createElement("div", {
                            style: {
                                flexGrow: 1,
                            },
                        })) : empty(), delay(() => {
                            let el_52;
                            return singleton((el_52 = Caption1, createElement(el_52, {
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: `${filteredLogs.length} av ${logs.length} utførelser`,
                            })));
                        }))));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                    let elems_11, el_54, elems_14, el_64, tupledArg, value_326, elems_13, props_101, el_56, name_33, el_62;
                    return append((filteredLogs.length === 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                        padding: 40,
                        textAlign: "center",
                    }], (elems_11 = [(el_54 = Body1, createElement(el_54, {
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: (logs.length === 0) ? "Ingen kjøringer registrert ennå" : "Ingen kjøringer matcher filteret",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : singleton(createElement("div", createObj(ofArray([["style", {
                        width: 100 + "%",
                        overflowX: "auto",
                    }], (elems_14 = [(el_64 = DataGrid, createElement(el_64, createObj(ofArray([dataGrid_items_Z6D8BD2B8(filteredLogs), ["columns", toArray(columns)], ["sortable", true], (tupledArg = patternInput_4[0], ["sortState", {
                        sortColumn: unwrap(tupledArg[0]),
                        sortDirection: tupledArg[1],
                    }]), ["onSortChange", (delegateArg_16, delegateArg_1_5) => {
                        const sortState_1 = delegateArg_1_5;
                        patternInput_4[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
                    }], ["resizableColumns", !isMobile], (value_326 = columnSizingOptions, ["columnSizingOptions", isEmpty(value_326) ? {} : createObj(toList(delay(() => collect((matchValue_4) => singleton([matchValue_4[0], createObj(matchValue_4[1])]), value_326))))]), ["style", {
                        minWidth: 100 + "%",
                    }], ["getRowId", (delegateArg_17) => delegateArg_17.Id], (elems_13 = [(props_101 = singleton_1((el_56 = DataGridRow, createElement(el_56, {
                        appearance: "brand",
                        children: (delegateArg_18, delegateArg_1_6) => {
                            const props_96 = singleton_1(delegateArg_18.renderHeaderCell());
                            const name_31 = DataGridHeaderCell;
                            return createElement(name_31, {
                                children: reactApi.Children.toArray(Array.from(props_96)),
                            });
                        },
                    }))), (name_33 = DataGridHeader, createElement(name_33, {
                        children: reactApi.Children.toArray(Array.from(props_101)),
                    }))), (el_62 = DataGridBody, createElement(el_62, {
                        children: (delegateArg_20) => {
                            const trd = delegateArg_20;
                            const el_60 = DataGridRow;
                            return createElement(el_60, {
                                key: trd.rowId,
                                onClick: (_arg_11) => {
                                    setSelectedLog(trd.item);
                                },
                                style: {
                                    cursor: "pointer",
                                },
                                children: (delegateArg_19, delegateArg_1_7) => {
                                    let elems_12;
                                    const tcd_1 = delegateArg_19;
                                    const el_58 = DataGridCell;
                                    return createElement(el_58, createObj(ofArray([["key", tcd_1.columnId], (elems_12 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])));
                                },
                            });
                        },
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))), delay(() => {
                        let el_92, elems_23;
                        return singleton((el_92 = OverlayDrawer, createElement(el_92, createObj(ofArray([["open", selectedLog != null], ["position", "end"], ["size", "medium"], ["onOpenChange", (_arg_13, value_1_60) => {
                            if (!value_1_60.open) {
                                setSelectedLog(undefined);
                            }
                        }], (elems_23 = toList(delay(() => {
                            let props_125, el_70, el_68, el_66, name_37;
                            if (selectedLog != null) {
                                const log_7 = selectedLog;
                                return append(singleton((props_125 = singleton_1((el_70 = DrawerHeaderTitle, createElement(el_70, {
                                    heading: "Detaljer for kjøring",
                                    action: (el_68 = Button, createElement(el_68, {
                                        appearance: "subtle",
                                        icon: (el_66 = DismissRegular, createElement(el_66, {
                                            fontSize: 20,
                                        })),
                                        onClick: (_arg_14) => {
                                            setSelectedLog(undefined);
                                        },
                                    })),
                                }))), (name_37 = DrawerHeader, createElement(name_37, {
                                    children: reactApi.Children.toArray(Array.from(props_125)),
                                })))), delay(() => {
                                    let props_162, elems_22, name_56;
                                    return singleton((props_162 = singleton_1(createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 18 + "px ",
                                        padding: ((12 + "px ") + 0) + "px",
                                    }], (elems_22 = toList(delay(() => {
                                        let elems_17, el_74, elems_15, el_72, el_78, elems_16, el_76;
                                        return append(singleton(createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            gap: 8 + "px ",
                                            flexWrap: "wrap",
                                        }], (elems_17 = [(el_74 = Badge, createElement(el_74, createObj(ofArray([["shape", "rounded"], ["appearance", "tint"], statusColor(log_7.Status), (elems_15 = [(el_72 = Text$, createElement(el_72, {
                                            children: statusLabel(log_7.Status),
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])])))), (el_78 = Badge, createElement(el_78, createObj(ofArray([["shape", "rounded"], ["appearance", "tint"], scopeColor(log_7.RuleScope), (elems_16 = [(el_76 = Text$, createElement(el_76, {
                                            children: scopeLabel(log_7.RuleScope),
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))), delay(() => {
                                            const renderField = (label, value_403) => {
                                                let elems_18, el_80;
                                                return createElement("div", createObj(ofArray([["style", {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 4 + "px ",
                                                }], (elems_18 = [(el_80 = Caption2, createElement(el_80, {
                                                    style: {
                                                        color: tokens.colorNeutralForeground3,
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",
                                                        fontWeight: 600,
                                                    },
                                                    children: label,
                                                })), value_403], ["children", reactApi.Children.toArray(Array.from(elems_18))])])));
                                            };
                                            const textField = (label_1, value_418) => {
                                                let el_82;
                                                return renderField(label_1, (el_82 = Body1, createElement(el_82, {
                                                    style: {
                                                        color: tokens.colorNeutralForeground1,
                                                    },
                                                    children: value_418,
                                                })));
                                            };
                                            return append(singleton(textField("Tidspunkt", ((toString(log_7.ExecutedAt, "dd. MMM yyyy HH:mm:ss") + " (") + relativeTime(log_7.ExecutedAt)) + ")")), delay(() => append(singleton(textField("Reglen", log_7.RuleName)), delay(() => {
                                                let matchValue_5, name_43;
                                                return append((matchValue_5 = log_7.UserName, (matchValue_5 != null) ? ((log_7.UserId != null) ? ((name_43 = matchValue_5, singleton(textField("Bruker", name_43)))) : singleton(defaultOf())) : singleton(defaultOf())), delay(() => {
                                                    let matchValue_8;
                                                    return append((matchValue_8 = log_7.TrackName, (matchValue_8 == null) ? singleton(defaultOf()) : singleton(textField("Læringsløp", matchValue_8))), delay(() => {
                                                        let matchValue_9;
                                                        return append((matchValue_9 = log_7.TrackLevelName, (matchValue_9 == null) ? singleton(defaultOf()) : singleton(textField("Nivå", matchValue_9))), delay(() => {
                                                            let matchValue_10;
                                                            return append((matchValue_10 = log_7.CycleStartDate, (matchValue_10 == null) ? singleton(defaultOf()) : singleton(textField("Syklus-dato", toString(matchValue_10, "dd. MMM yyyy HH:mm") + " — utløserens unike nøkkel; reglen kjører kun én gang per dato"))), delay(() => {
                                                                let matchValue_11, el_86, elems_19, props_147, el_84, name_46;
                                                                return append((matchValue_11 = log_7.ErrorMessage, (matchValue_11 == null) ? singleton(defaultOf()) : singleton(renderField("Feilmelding", (el_86 = MessageBar, createElement(el_86, createObj(ofArray([["intent", "error"], ["layout", "multiline"], ["shape", "rounded"], (elems_19 = [(props_147 = singleton_1((el_84 = Text$, createElement(el_84, {
                                                                    children: matchValue_11,
                                                                }))), (name_46 = MessageBarBody, createElement(name_46, {
                                                                    children: reactApi.Children.toArray(Array.from(props_147)),
                                                                })))], ["children", reactApi_1.Children.toArray(Array.from(elems_19))])]))))))), delay(() => {
                                                                    let elems_21;
                                                                    const matchValue_12 = log_7.ActionDetails;
                                                                    let matchResult, raw_1;
                                                                    if (matchValue_12 != null) {
                                                                        if (!isNullOrWhiteSpace(matchValue_12)) {
                                                                            matchResult = 0;
                                                                            raw_1 = matchValue_12;
                                                                        }
                                                                        else {
                                                                            matchResult = 1;
                                                                        }
                                                                    }
                                                                    else {
                                                                        matchResult = 1;
                                                                    }
                                                                    switch (matchResult) {
                                                                        case 0: {
                                                                            const entries = (function(s){ try { var o = JSON.parse(s); if (o == null || typeof o !== 'object' || Array.isArray(o)) return []; return Object.entries(o).map(function(e){ var k = e[0]; var v = e[1]; var label = k.charAt(0).toUpperCase() + k.slice(1); var str = (typeof v === 'string') ? v : JSON.stringify(v); return [label, str]; }); } catch (_) { return []; } })(raw_1);
                                                                            return (entries.length > 0) ? singleton(renderField("Detaljer", createElement("div", createObj(ofArray([["style", {
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                                                                                borderRadius: 4,
                                                                                overflow: "hidden",
                                                                            }], (elems_21 = toList(delay(() => collect((matchValue_13) => {
                                                                                let elems_20, el_88, el_90;
                                                                                return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["gap", 12 + "px "]), delay(() => append(singleton(["padding", ((10 + "px ") + 12) + "px"]), delay(() => append(singleton(["backgroundColor", tokens.colorNeutralBackground1]), delay(() => ((matchValue_13[0] > 0) ? singleton(["borderTop", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke3]) : empty()))))))))))))], (elems_20 = [(el_88 = Caption1, createElement(el_88, {
                                                                                    style: {
                                                                                        color: tokens.colorNeutralForeground3,
                                                                                        minWidth: 110,
                                                                                        flexShrink: 0,
                                                                                        fontWeight: 500,
                                                                                    },
                                                                                    children: matchValue_13[1][0],
                                                                                })), (el_90 = Body1, createElement(el_90, {
                                                                                    style: {
                                                                                        color: tokens.colorNeutralForeground1,
                                                                                        wordBreak: "break-word",
                                                                                        flexGrow: 1,
                                                                                    },
                                                                                    children: matchValue_13[1][1],
                                                                                }))], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))));
                                                                            }, indexed(entries)))), ["children", reactApi.Children.toArray(Array.from(elems_21))])]))))) : singleton(renderField("Detaljer", createElement("pre", {
                                                                                style: {
                                                                                    padding: ((12 + "px ") + 14) + "px",
                                                                                    backgroundColor: tokens.colorNeutralBackground2,
                                                                                    border: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
                                                                                    borderRadius: 4,
                                                                                    fontSize: 12 + "px",
                                                                                    fontFamily: "monospace",
                                                                                    overflowX: "auto",
                                                                                    margin: 0,
                                                                                    color: tokens.colorNeutralForeground1,
                                                                                },
                                                                                children: raw_1,
                                                                            })));
                                                                        }
                                                                        default:
                                                                            return singleton(defaultOf());
                                                                    }
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                }));
                                            }))));
                                        }));
                                    })), ["children", reactApi.Children.toArray(Array.from(elems_22))])])))), (name_56 = DrawerBody, createElement(name_56, {
                                        children: reactApi.Children.toArray(Array.from(props_162)),
                                    }))));
                                }));
                            }
                            else {
                                return singleton(defaultOf());
                            }
                        })), ["children", reactApi_1.Children.toArray(Array.from(elems_23))])])))));
                    }));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_24))])])));
    }
}

function EditGlobalRuleDialogWrapper(editGlobalRuleDialogWrapperInputProps) {
    const onClose = editGlobalRuleDialogWrapperInputProps.onClose;
    const onUpdate = editGlobalRuleDialogWrapperInputProps.onUpdate;
    const rule = editGlobalRuleDialogWrapperInputProps.rule;
    const setCtx = useCtx()[1];
    return createElement(EditRuleDialog, {
        existingRule: new ExistingRule(0, [rule]),
        onSave: (updateRule) => {
            if (updateRule.tag === 0) {
                const ruleUpdate = updateRule.fields[0];
                let pr_1;
                const pr = startAsPromise(Rule.UpdateGlobalRule(ruleUpdate));
                pr_1 = (pr.then((_arg) => {
                    if (_arg.tag === 1) {
                        errorToast(setCtx, "updateGlobalRuleError", "Kunne ikke oppdatere", "", undefined);
                    }
                    else {
                        successToast(setCtx, `updateGlobalRule-${rule.Id}`, "Oppdatert", `${ruleUpdate.Name} ble oppdatert`);
                        onUpdate(_arg.fields[0]);
                        onClose();
                    }
                }));
                void (pr_1.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }
        },
        onClose: onClose,
    });
}

function AddGlobalRuleDialogWrapper(addGlobalRuleDialogWrapperInputProps) {
    const onAdd = addGlobalRuleDialogWrapperInputProps.onAdd;
    const isMobile = addGlobalRuleDialogWrapperInputProps.isMobile;
    const setCtx = useCtx()[1];
    let trigger;
    const el_2 = Button;
    trigger = createElement(el_2, createObj(toList(delay(() => append(singleton(["appearance", "primary"]), delay(() => {
        let el;
        return append(singleton(["icon", (el = AddRegular, createElement(el, {}))]), delay(() => append(isMobile ? singleton(["style", {
            whiteSpace: "nowrap",
        }]) : empty(), delay(() => singleton(["children", isMobile ? "Ny" : "Ny automatisering"])))));
    }))))));
    return createElement(AddRuleDialog, {
        scope: new DialogScope(0, []),
        trigger: trigger,
        onSave: (newRule) => {
            if (newRule.tag === 0) {
                const rule = newRule.fields[0];
                let pr_1;
                const pr = startAsPromise(Rule.AddGlobalRule(rule));
                pr_1 = (pr.then((_arg) => {
                    if (_arg.tag === 1) {
                        errorToast(setCtx, "addGlobalRuleError", "Kunne ikke opprette", "", undefined);
                    }
                    else {
                        const savedRule = _arg.fields[0];
                        successToast(setCtx, `addGlobalRule-${savedRule.Id}`, "Opprettet", `${rule.Name} ble lagt til`);
                        onAdd(savedRule);
                    }
                }));
                void (pr_1.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }
        },
    });
}

export function RulePage() {
    let elems_3;
    const setCtx = useCtx()[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const patternInput_1 = reactApi.useState([]);
    const setGlobalRules = patternInput_1[1];
    const globalRules = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setIsLoading = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setEditingRule = patternInput_3[1];
    useEffectDisposableOptOnce(() => {
        let pr_1;
        const pr = startAsPromise(Rule.GetAllGlobalRules());
        pr_1 = (pr.then((_arg) => {
            if (_arg.tag === 1) {
                errorToast(setCtx, "getGlobalRulesError", "Kunne ikke hente automatisering", "", undefined);
                setIsLoading(false);
            }
            else {
                setGlobalRules(_arg.fields[0]);
                setIsLoading(false);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        return undefined;
    });
    return createElement("div", createObj(ofArray([["style", {
        padding: isMobile ? 12 : 20,
        display: "flex",
        flexDirection: "column",
        maxWidth: 1200,
        overflow: "hidden",
    }], (elems_3 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "flex-start"]), delay(() => append(singleton(["gap", 16 + "px "]), delay(() => (isMobile ? singleton(["flexDirection", "column"]) : singleton(["justifyContent", "space-between"])))))))))))], (elems_1 = [createElement("div", createObj(singleton_1((elems = toList(delay(() => {
            let el;
            return append(singleton((el = Title2, createElement(el, {
                children: "Global automatisering",
            }))), delay(() => {
                let el_2, value_24;
                return !isMobile ? singleton((el_2 = Body1, createElement(el_2, createObj(ofArray([["style", {
                    color: tokens.colorNeutralForeground3,
                    marginTop: 4,
                    display: "block",
                    maxWidth: 640,
                }], (value_24 = "Administrer automatisering for varsler og handlinger som gjelder alle brukere. Automatisering for spesifikke læringsløp konfigureres i læringsløpbyggeren.", ["children", value_24])]))))) : empty();
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])))), createElement(AddGlobalRuleDialogWrapper, {
            isMobile: isMobile,
            onAdd: (rule) => {
                setGlobalRules(append_1(globalRules, [rule]));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let array_3;
            return append(singleton(SectionHeader("Automatiseringer", `${globalRules.length} totalt · ${(array_3 = globalRules.filter((_arg_2) => _arg_2.Enabled), array_3.length)} aktive`)), delay(() => {
                let el_6, elems_2;
                return append(patternInput_2[0] ? singleton((el_6 = Skeleton, createElement(el_6, createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8 + "px ",
                    width: 100 + "%",
                }], (elems_2 = toList(delay(() => map_1((_arg_3) => {
                    const el_4 = SkeletonItem;
                    return createElement(el_4, {
                        style: {
                            height: 56,
                        },
                        animation: "wave",
                        shape: "rectangle",
                    });
                }, toList(rangeDouble(1, 1, 4))))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))) : singleton(createElement(RulesDataGrid, {
                    globalRules: globalRules,
                    isMobile: isMobile,
                    onEdit: (rule_1) => {
                        setEditingRule(rule_1);
                    },
                    onDelete: (ruleId_1) => {
                        let value_46;
                        const ruleId = ruleId_1 | 0;
                        let pr_3;
                        const pr_2 = startAsPromise(Rule.DeleteGlobalRule(ruleId));
                        pr_3 = (pr_2.then((_arg_1) => {
                            if (_arg_1.tag === 1) {
                                errorToast(setCtx, `deleteGlobalRuleError-${ruleId}`, "Kunne ikke slette", "", undefined);
                            }
                            else {
                                setGlobalRules(globalRules.filter((r) => (r.Id !== ruleId)));
                                successToast(setCtx, `deleteGlobalRule-${ruleId}`, "Slettet", "Automatiseringen ble slettet");
                            }
                        }));
                        value_46 = (void (pr_3.catch((ex_1) => {
                            toastServerError(setCtx, ex_1);
                        })));
                    },
                })), delay(() => {
                    let matchValue, rule_2;
                    return append((matchValue = patternInput_3[0], (matchValue == null) ? singleton(defaultOf()) : ((rule_2 = matchValue, singleton(createElement(EditGlobalRuleDialogWrapper, {
                        rule: rule_2,
                        onUpdate: (updatedRule) => {
                            setGlobalRules(map_2((r_1) => {
                                if (r_1.Id === updatedRule.Id) {
                                    return updatedRule;
                                }
                                else {
                                    return r_1;
                                }
                            }, globalRules));
                        },
                        onClose: () => {
                            setEditingRule(undefined);
                        },
                    }))))), delay(() => append(singleton(SectionHeader("Kjøringslogg", "Alle utførte automatiseringer og brukerne som ble berørt")), delay(() => singleton(createElement(ExecutionLogSection, {
                        isMobile: isMobile,
                    }))))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=RulePage.jsx.map
